/*
 * @Description: Description
 * @Author: zhaoqianqian
 * @Date: 2021-10-29 13:58:43
 * @LastEditors: liyunfei 3090384495@qq.com
 * @LastEditTime: 2026-04-01 18:43:26
 */
import csCZLocale from 'element-ui/lib/locale/lang/cs-CZ'
import agrEn from './agr-en'
export default {
    // ai报告相关
    ai: {
        report: "Interpretace zprávy AI",
        train: "Osnova tréninku",
        loading: "Načítání, čekejte prosím...",
        loadingError1: "Nepodařilo se načíst zprávu",
        loadingError2: "Omlouváme se za nepříjemnosti. Zkuste to prosím později.",
    },
    // 登录页面
    login: {
        loginAndRegister: 'Registrovat/Přihlášení',
        registerAndLogin: 'Přihlášení/Registrovat',
        userLogin: 'Přihlášení',
        title: 'Mobilní a e-mailové účty jsou oddělené. Zkontrolujte, prosím, typ účtu.',
        mobileLogin: 'Mobil',
        emailLogin: 'E-mail',
        email: 'E-mail',
        loginBtn: 'Přihlášení',
        autoLogin: 'Automatické přihlášení příště',
        retransmission: '{item} sekund zbývá',
        formList: [
            {
                label: 'Zadejte prosím své mobilní číslo',
                placeholder: 'Získat ověřovací kód',
            },
            {
                label: 'Ověřovací kód',
                placeholder: '',
            },
            {
                label: 'Zadejte prosím svůj e-mail',
            },
        ],
        btn: {
            submit: 'Vytvořit nový účet',
            title: 'Přesné informace jsou velmi důležité. Vyplňte je prosím pečlivě.',
        },
        rule: {
            phone: {
                requiredMsg: 'Nesprávný formát mobilního čísla',
                patternMsg: 'Mobilní číslo není registrováno. Vytvořte si prosím nový účet.',
            },
            authCode: {
                requiredMsg: 'Nesprávný ověřovací kód. Zkuste to prosím znovu.',
            },
            email: {
                requiredMsg: 'Nesprávný formát e-mailu',
                patternMsg: 'E-mail není registrován. Vytvořte si prosím nový účet.',
            },
        },
        codeSuccess: 'Ověřovací kód odeslán. Zkontrolujte prosím.',
        success: 'Úspěšně odesláno',
        error: 'Odeslání se nezdařilo',
        loginSuccess: 'Přihlášení úspěšné',
        account: {
            accountTitle: 'Přihlášení',
            registerTitle: 'Registrovat',
            resetTitle: 'Nastavit heslo',
            password: 'Heslo',
            placeholder: 'Zadejte prosím své heslo',
            codeLogin: 'Přihlášení pomocí ověřovacího kódu',
            accountLogin: 'Přihlášení pomocí hesla',
            forgotPassword: 'Zapomenuté heslo?',
            registerTips:[
                'Nemáte účet?', 
                'Registrovat', 
                'Účet již existuje',
                '立即注册',
            ],
            checkRule: [
                '8-20 znaků',
                'Alespoň jedno velké písmeno',
                'Alespoň jedno malé písmeno',
                'Alespoň jedno číslo', 
                'Hesla se neshodují'
            ],
            errorTips: [
                'Nesprávné heslo', 
                'Přihlášení se nezdařilo', 
                'Účet neexistuje'
            ],
            reset:[
                'Obnovit heslo', 
                "Další",
                'Nové heslo nemůže být stejné jako staré', 
                'Přeskočit',
                'Heslo úspěšně nastaveno'
            ],
            setPasswordTips:'Heslo musí mít 8–20 znaků a obsahovat velká písmena, malá písmena a číslice.',
            confirmPassword: "Potvrzení hesla",
        },
        switchButton: 'Přihlášení Heslem',
        switchButton1: 'Přihlášení pomocí ověřovacího kódu',
        loginTips: 'Neregistrované účty budou po úspěšném přihlášení automaticky zaregistrovány.',
        otherLogin: 'Další Možnosti Přihlášení',
        newEmailLogin: 'Přihlášení E-Mailem',
        newPhoneLogin: 'Přihlášení Telefonním Číslem',
        bindLineTips:'Nebo',
        bindEmail: 'Přihlášení s Propojeným E-Mailem',
        bindPhone: 'Přihlášení s Propojeným Telefonním Číslem',
        bindAndContinue: "Propojit a pokračovat",
        bind: "Propojit",
        bindEmailTitle: 'Propojit e-mail',
        bindEmailTips1: "Nenalezeny info o e-mailu {item}",
        bindEmailTips2: "Pro pokračování propojte e-mail",
        bindEmailTips3: "E-mail není propojen. Propojte pro přihlášení a obnovu hesla.",
        boundTitle: 'Už jste se registrovali?',
        boundCenterTitle1:'Pokud jste nový uživatel',
        boundCenterTips1:'Vytvořte si účet a začněte',
        boundCenterTitle2:'Pokud již máte účet',
        boundCenterTips2:'Propojte pro synchronizaci dat',
        boundCenterTips3:'Propojte prosím registrovaný účet',
        boundCenterTips4:'Doporučeno',
        boundCenterTips5:'Propojit {item} se stávajícím účtem',
        boundCenterTips6:'Data a přehledy se synchronizují',
        boundButton1: 'Vytvořit účet přes {item}',
        boundButton2: 'Propojit stávající účet',
        phoneCode:"Přihlášení přes SMS",
        phonePassword:"Mobil a heslo",
        emailCode:"Přihlášení přes e-mail",
        emailPassword:"E-mail a heslo",
        accountDoesNotExist:"Tento účet ještě není zaregistrován. Dokončete registraci pomocí e-mailového ověřovacího kódu nebo přes {item}.",
        toRegister:"Zaregistrovat se",
        bindNow: "Propojit nyní",
        bindError:[
            'Propojení Selhalo',
            'Odpojení Úspěšné',
            'Odpojení Selhalo',
            'Autorizace Selhala',
            'Autorizace Selhala, Nepodařilo Se Získat Informace o Účtu.',
            'Propojení Úspěšné',
            'Účet Neexistuje, Propojte Prosím Svůj Zaregistrovaný Účet.',
            'Propojení Selhalo, tento účet je již propojen s účtem {item}  [{nickname}].',
            'Autorizováno a zaregistrováno jako účet, zrušení propojení není podporováno',
            'Účet neexistuje, pro přihlášení a registraci použijte ověřovací kód',
        ],
        accountSecurity: {
            faceBook:'Účet Facebook',
            google: 'Účet Google',
            isBind: 'Nepropojeno',
            dialogTitle: 'Opravdu Chcete Odpojit Účet?',
            dialogCenter: 'Po odpojení {item} jej již nebudete moci používat k přihlášení do tohoto účtu.',
            bindFailure:'Propojení Selhalo',
            bindFailureTips: 'Váš účet {item} je již propojen s níže uvedeným účtem. Chcete-li jej propojit s aktuálním účtem, přihlaste se nejprve k níže uvedenému účtu a propojení zrušte.',
            returnButton:'Potvrdit A Zpět'
        },
        bindEmailError: [
            "E-mail již existuje."
        ],

    },
    // 注册页面
    register: {
        mobileRegister: 'Registrovat pomocí mobilu',
        emailRegister: 'Registrovat pomocí e-mailu',
        enroll: 'Mobilní číslo je již registrováno.',
        enrollEmail: 'Tento e-mail je již registrován.',
        search: 'Hledat',
        title: 'Mobilní a e-mailové účty jsou oddělené. Zkontrolujte, prosím, typ účtu.',
        needRead: {
            agree: 'Přečetl/a jsem si a souhlasím',
            privacy: 'Zásady ochrany osobních údajů uživatele',
        },
        register: 'Registrovat',
        check: 'Zaškrtněte "Zásady ochrany osobních údajů uživatele"',
        newUser: 'Registrace nového uživatele',
        form: {
            labelList: ['Jméno', '* Pohlaví', '* Výška', '* Věk'],
        },
        placeholder: ['Zadejte prosím své jméno', 'Zadejte prosím svou výšku', 'Zadejte prosím svůj věk'],
        unit: ['Metrické', 'Imperiální', 'roků'],
        sexOptions: {
            male: 'Muž',
            female: 'Žena',
        },
        btn: 'Odeslat',
        rules: {
            metricheight: ['Povolený rozsah výšky je 2ft3in–6ft7in. Zadejte prosím znovu.'],
            heightMsg: ['Povolený rozsah výšky je 70–200 cm. Zadejte prosím znovu.'],
            ageMsg: ['Povolený věkový rozsah je 10–99 let. Zadejte prosím znovu.'],
            agePointMsg: ['Neplatný vstup: věk musí být celé číslo. Zadejte prosím platný věk.'],
        },
        success: 'Registrace proběhla úspěšně.',
        userMessage: 'Zadejte prosím své uživatelské jméno',
        verify: 'Zadejte prosím 4místný ověřovací kód',
        errorMsg: 'Výška musí být celé číslo. Zadejte prosím znovu.',
        abnormalMsg: 'Chyba registrace',
    },
    // 模型合成
    model: {
        loading: 'Model se generuje, čekejte prosím',
        modelLoading: 'Načítání modelu...',
        tabPane: [
            {
                title: 'Technologie hlubokého snímání',
                msg: 'Přesné zachycení detailů těla pomocí 3D skenování pro zajištění milimetrové přesnosti měření obvodů, aby byly změny těla po cvičení jasně viditelné.',
            },
            {
                title: 'Algoritmus tělesného složení BDA',
                msg: 'Visbody používá pokročilý systém BDA k určení tělesného složení, který nabízí hodnocení založené na objemu pro lepší posouzení zdravotních rizik spojených s obezitou.',
            },
            {
                title: 'Možné faktory chyb',
                msg: 'Volné oblečení nebo cizí předměty mohou způsobit chyby. Pro co nejpřesnější výsledky noste přiléhavé oblečení nebo omezte svrchní oděvy.',
            },
            {
                title: 'Vstup do zprávy',
                msg: 'Doporučujeme si stránku uložit do záložek pro pozdější přístup. Tuto zprávu si také můžete poslat na svůj e-mail.',
            },
        ],
        collect: ['Uložte si prosím tuto stránku do záložek.', 'Pro snadný přístup k zprávě později.'],
        know: 'Rozumím',
        reminder: [
            'Přátelské připomenutí',
            'Váš 3D model je vygenerován. Zkuste přejetím prstem model otočit.',
            'Vaše zpráva je připravena. Klikněte na "Zobrazit zprávu" pro její zobrazení.',
            'Hodnocení držení těla se nezdařilo. Prohlédněte si prosím zprávu o složení těla.',
            'Složení těla se nezdařilo. Prohlédněte si prosím zprávu o hodnocení držení těla.',
            'Měření se nezdařilo. Zkuste to prosím znovu na zařízení.',
            'Složení těla se nezdařilo. Zkuste to prosím znovu na zařízení.',
            'Hodnocení držení těla se nezdařilo. Zkuste to prosím znovu na zařízení.',
        ],
        btn: {
            viewReport: 'Zobrazit zprávu',
            bodyReport: 'Zobrazit zprávu o složení těla',
            postureReport: 'Zobrazit zprávu o držení těla',
            lastReport: 'Zobrazit předchozí zprávu',
            loading: 'Načítání...',
        },
    },
    // 报告
    report: {
        btn: {
            download: 'Stáhnout zprávu',
            send: 'Odeslat zprávu',
            report: 'Zpráva',
        },
        reportSuccess: 'Zpráva byla úspěšně vygenerována',
        tabPane: {
            labelList: ['Čas měření', 'Položka', 'Tělesné složení', 'Hodnocení držení těla', 'Funkce ramen'],
        },
        sendEmail: 'Odeslat na e-mail:',
        requiredMsg: 'Zadejte prosím svou e-mailovou adresu',
        patternMsg: 'Zadejte prosím platnou e-mailovou adresu',
        send: 'Odeslat',
        download: 'Stáhnout zprávu',
        sendReport: 'Odeslat zprávu',
    },
    // 侧边栏
    sidebar: {
        successMsg: {
            sex: 'Pohlaví úspěšně aktualizováno',
            height: 'Výška úspěšně aktualizována',
            age: 'Věk úspěšně aktualizován',
        },
        logOut: 'Odhlásit se',
        personal: 'Profilové centrum',
        cut: 'Přepnout jednotky/jazyk',
        changeSort: 'Přepnout produktovou zprávu',
        setPassword: 'Nastavit/změnit heslo',
        accountSecurity: 'Účet a Bezpečnost',
        describe: 'Po přepnutí modelu produktu se zobrazí všechny související zprávy.',
        describeBtn: 'Po přepnutí modelu produktu budete přesměrováni na nejnovější zprávu.',
        descReport: 'Produktová zpráva úspěšně přepnuta',
        unit: ['Metrické (kg, cm)', 'Imperiální (ft, in, lb)'],
        read: {
            reading: 'Přečíst',
            privacy: 'Zásady ochrany osobních údajů uživatele',
        },
        setting: 'Nastavení',
        form: {
            labelList: ['Mobilní číslo', 'Jednotky', 'Jazyk', 'Přezdívka', 'Pohlaví', 'Výška', 'Věk'],
        },
        placeholder: ['Upravit přezdívku', 'Upravit pohlaví', 'Upravit výšku', 'Upravit věk'],
        btn: {
            cancelBtn: 'Zrušit',
            accomplishBtn: 'Hotovo',
            confirmBtn: 'Potvrdit',
        },
        dialog: [
            'Pohlaví je důležitým faktorem při analýze tělesného složení. Jeho změna může ovlivnit srovnání s minulými daty. Potvrdit změnu?',
            'Výška je důležitým faktorem při analýze tělesného složení. Její změna může ovlivnit srovnání s minulými daty. Potvrdit změnu?',
            'Věk je důležitým faktorem při analýze tělesného složení. Jeho změna může ovlivnit srovnání s minulými daty. Potvrdit změnu?',
        ],
        rules: {
            metricheight: ['Zadejte prosím výšku v rozsahu (2ft3in–6ft7in)'],
            heightMsg: ['Zadejte prosím výšku v rozsahu (70–200cm)'],
            ageMsg: ['Zadejte prosím věk v rozsahu (10–99 let)', 'Neplatný vstup: věk musí být celé číslo. Zadejte prosím platný věk.'],
        },
        heightMsg: 'Vyberte prosím znovu výšku',
        ageMsg: 'Vyberte prosím znovu věk',
        ModelBinding: 'Někdo naskenoval kód před vámi. Proveďte prosím nové měření.',
        ReportEmpty: {
            title: 'Zatím nemáte žádné související zprávy',
            desc: 'Najděte Visbody 3D skener a proveďte měření!',
        },
    },
    // 无测量报告
    modelBinding: {
        desc: 'Někdo naskenoval kód před vámi. Proveďte prosím nové měření.',
    },
    // 扫码模型已被绑定
    reportEmpty: {
        title: 'Zatím nemáte žádné související zprávy',
        desc: 'Najděte Visbody 3D skener a proveďte měření!',
        descS30: 'Najděte Visbody-S30 3D skener a proveďte měření!',
        descM30: 'Najděte Visbody-M30 3D skener a proveďte měření!',
    },
    // 用户信息
    userInfo: {
        height: 'Výška:',
        age: 'Věk:',
        unit: 'roků',
        weight: 'Hmotnost',
    },
    // 体成分
    mass: {
        title: 'Přehled tělesného složení',
        titles: 'Tělesné složení',
        springFrame: '',
        massFrame: 'Pro dnešek nejsou k dispozici žádná data měření',
        contrast: 'Vyberte zprávu k porovnání',
        contrastReport: 'Zvolte srovnávací zprávu',
        noRecord: 'Žádný záznam',
        score: 'bodů',
        status: 'Váš aktuální stav tělesného složení',
        WT: 'Hmotnost',
        PBF: 'Procento tělesného tuku',
        endSymbol: '。',
        // 测量相关
        measure: {
            value: 'Hodnoty',
            standardRange: 'Standardní rozsah',
            comparedWithLastLime: 'Změna',
            comparedNet: 'Změna',
            current: '本次测量分数',
            WT: 'Hmotnost',
            FFM: 'Tělesná hmotnost bez tuku',
            BFM: 'Hmota tělesného tuku',
            LM: 'Svalová hmota',
            TBW: 'Celková tělesná voda',
            SM: 'Kosterní svalstvo',
            PROTEIN: 'Bílkoviny',
            TM: 'Anorganické soli',
            BMR: 'Bazální metabolismus',
            WHR: 'Poměr pasu a boků',
            BMI: 'BMI',
            PBF: 'Procento tělesného tuku',
            VFG: 'Úroveň viscerálního tuku',
            unit: 'kg',
            BMRUnit: 'kcal/den',
        },
        // 定义解读
        explain: [
            {
                title: 'Hmotnost',
                msg: 'Hmotnost je součtem tělesné vody, bílkovin, anorganických solí a tělesného tuku.',
            },
            {
                title: 'Tělesná hmotnost bez tuku',
                msg: 'Tělesná hmotnost bez tuku je celková tělesná hmotnost bez tuku.',
            },
            {
                title: 'Hmota tělesného tuku',
                msg: 'Tělesný tuk je součtem podkožního, viscerálního a mezisvalového tuku.',
            },
            {
                title: 'Svalová hmota',
                msg: 'Svalová hmota je soubor libových tkání v lidském těle, včetně kosterních, hladkých a srdečních svalů.',
            },
            {
                title: 'Celková tělesná voda',
                msg: 'Tělesná voda tvoří 50–70 % tělesné hmotnosti. Nachází se hlavně v buňkách a tekutinách, většinou ve svalových buňkách.',
            },
            {
                title: 'Kosterní svalstvo',
                msg: 'Kosterní svalstvo, také nazývané příčně pruhované svalstvo, je připojeno ke kostem. Zde se ukazuje jeho množství.',
            },
            {
                title: 'Bílkoviny',
                msg: 'Bílkoviny jsou pevné látky obsahující dusík, přítomné ve všech buňkách a klíčovou složkou svalové hmoty.',
            },
            {
                title: 'Anorganické soli',
                msg: 'Anorganické soli tvoří asi 5 % tělesné hmotnosti.',
            },
            {
                title: 'Bazální metabolismus',
                msg: 'BMR je celková energie, kterou tělo spotřebuje za den v bdělém a klidovém stavu, neovlivněné pohybem, jídlem nebo teplotou.',
            },
            {
                title: 'Poměr pasu a boků',
                msg: 'Poměr pasu a boků (WHR) je důležitým ukazatelem pro hodnocení centrální obezity.',
            },
            {
                title: 'BMI',
                msg: 'BMI se používá k hodnocení obezity a je běžným mezinárodním standardem.',
            },
            {
                title: 'Procento tělesného tuku',
                msg: 'Procento tělesného tuku označuje podíl tuku na celkové tělesné hmotnosti.',
            },
            {
                title: 'Úroveň viscerálního tuku',
                msg: 'Úroveň viscerálního tuku je důležitým ukazatelem pro posouzení skryté obezity.',
            },
            {
                title: 'Intracelulární tekutina (ICW)',
                msg: 'Intracelulární tekutina je tělní tekutina obsažená uvnitř buněk a tvoří základní součást cytoplazmy.',
            },
            {
                title: 'Extracelulární tekutina (ECW)',
                msg: 'Extracelulární tekutina je tekutina vně buněk, včetně plazmy a intersticiální tekutiny.',
            },
            {
                title: 'Metabolický věk',
                msg: 'Metabolický věk se vztahuje k výkonu těla a jeho metabolických funkcí souvisejících se zdravím.',
            },
            {
                title: 'Poměr ECW/TBW',
                msg: 'Poměr ECW/TBW je podíl extracelulární vody (ECW) na celkové tělesné vodě (TBW). Jde o důležitý ukazatel pro hodnocení rovnováhy tělesných tekutin.',
            },
        ],
        // 节段
        segment: {
            fat: 'Segmentální tuk',
            muscle: 'Segmentální sval',
            right: 'Pravá',
            left: 'Levá',
            standard: 'Normální',
            lowStandard: 'Pod',
            superStandard: 'Nad',
            peel: '(Tára)',
        },
    },
    // 体态
    shape: {
        title: 'Přehled hodnocení držení těla',
        titles: 'Hodnocení držení těla',
        status: 'Váš aktuální stav držení těla',
        suggest: 'Doporučení',
        possibility: ', ukazuje',
        models: {
            front: 'Zepředu',
            left: 'Levá strana',
            right: 'Pravá strana',
            top: 'Pohled zezadu',
            low: 'Podprůměrný',
            high: 'Nadprůměrný',
            normal: 'Normální',
        },
        item: {
            deviate: 'Hodnoty',
            result: 'Popis',
            normal: 'Normální',
            abnormal: 'Abnormální',
            keAbnormal: 'Možný problém',
            head: 'Předsunutá hlava',
            headSlant: 'Náklon hlavy',
            roundShoulderLeft: 'Otočená ramena doleva',
            roundShoulderRight: 'Kulatá záda (pravá strana)',
            highLowShoudler: 'Otočená ramena doprava',
            pelvis: 'Posun pánve vpřed/vzad',
            leftKneeCheck: 'Hodnocení levého kolena',
            rightKneeCheck: 'Hodnocení pravého kolena',
            leg: 'Typ nohou',
            leftLeg: 'Levá noha:',
            rightLeg: 'Pravá noha:',
        },
        // 定义解读
        explain: [
            {
                title: 'Předsunutá hlava',
                msg: 'Úhel mezi čarou od bodu ucha ke středu krku na levé straně a boční středovou čarou',
            },
            {
                title: 'Náklon hlavy',
                msg: 'Úhel mezi čarou od středu hlavy ke středu krku a přední středovou čarou',
            },
            {
                title: 'Otočená ramena doleva',
                msg: 'Úhel mezi nejvyšším bodem na levé straně zad a tečnou ramene',
            },
            {
                title: 'Kulatá záda (pravá strana)',
                msg: 'Úhel mezi nejvyšším bodem na pravé straně zad a tečnou ramene',
            },
            {
                title: 'Otočená ramena doprava',
                msg: 'Svislá vzdálenost mezi levým a pravým akromionem zezadu',
            },
            {
                title: 'Posun pánve vpřed/vzad',
                msg: 'Úhel mezi body krku, kyčle a kotníku na levém bočním pohledu',
            },
            {
                title: 'Hodnocení levého kolena',
                msg: 'Úhel mezi kyčlí, kolenem a kotníkem na levém bočním pohledu',
            },
            {
                title: 'Hodnocení pravého kolena',
                msg: 'Úhel mezi kyčlí, kolenem a kotníkem na pravém bočním pohledu',
            },
            {
                title: 'Typ nohou',
                msg: 'Úhel tvořený kyčlí, kolenem a kotníkem v čelním pohledu pro obě nohy',
            },
            {
                title: 'Předklon/Záklon Pánve',
                msg: 'Úhel Mezi Svislicí A Rovinou Vytvořenou Levým A Pravým Předním Horním Trnem Kyčelní Kosti A Stydkou Spojkou.'
            },
            {
                title: 'Rozdíl v Délce Nohou',
                msg: 'Výškový Rozdíl Mezi Nejnižšími Body Levého A Pravého Hýžďového Zhybu Od Země, Měřeno Ze Zadu.'
            }
        ],
        exception: [
            {
                title: 'Posunuto doleva',
                abnormal: '',
            },
            {
                title: 'Posunuto doprava',
                abnormal: '',
            },
            {
                title: 'Levá vyšší',
                abnormal: '',
            },
            {
                title: 'Pravá vyšší',
                abnormal: '',
            },
            {
                title: 'Zadní náklon pánve',
                abnormal: '',
            },
            {
                title: 'Přední posun pánve',
                abnormal: '',
            },
            {
                title: 'Hyperextenze levého kolena',
                abnormal: '',
            },
            {
                title: 'Flexe levého kolena',
                abnormal: '',
            },
            {
                title: 'Hyperextenze pravého kolena',
                abnormal: '',
            },
            {
                title: 'Flexe pravého kolena',
                abnormal: '',
            },
            {
                title: 'Typ nohou K',
                abnormal: '',
            },
            {
                title: 'Typ nohou D',
                abnormal: '',
            },
            {
                title: 'Typ nohou X',
                abnormal: '',
            },
            {
                title: 'Typ nohou O',
                abnormal: '',
            },
            {
                title: '骨盆前倾',
                abnormal: ''
            },
            {
                title: '骨盆后倾',
                abnormal: ''
            },
            {
                title: 'Abnormální Délka Levého Boku',
                abnormal: ''
            },
            {
                title: 'Abnormální Délka Pravého Boku',
                abnormal: ''
            }
        ],
    },
    newshape: {
        explain: [
            {
                msg: 'Vertikální vzdálenost mezi uchem a těžištěm těla',
            },
            {
                msg: 'Úhel mezi čarou spojující uši a vodorovnou čarou',
            },
            {
                msg: 'Vertikální vzdálenost mezi levým akromionem a těžištěm',
            },
            {
                msg: 'Vertikální vzdálenost mezi pravým akromionem a těžištěm',
            },
            {
                msg: 'Rozdíl mezi linií krční báze a akromionu (levá a pravá)',
            },
            {
                msg: 'Vertikální vzdálenost mezi kyčelním kloubem a těžištěm těla',
            },
            {
                msg: 'Úhel mezi kotníkem, 1 cm pod levým kolenem a kyčlí (sagitální rovina)',
            },
            {
                msg: 'Úhel mezi kotníkem, 1 cm pod pravým kolenem a kyčlí (sagitální rovina)',
            },
            {
                msg: 'Úhel mezi levou/pravou kyčlí, koleny a kotníky (koronální rovina)',
            },
        ],
        item: {
            pelvis: 'Přední posun pánve',
        },
    },
    // 围度信息
    girth: {
        title: 'Obvod těla',
        present: '(tentokrát)',
        noHistory: 'Žádná data',
        tpl: [
            {
                title: 'Obvod krku',
                key: 'neckGirth',
            },
            {
                title: 'Obvod levé paže',
                key: 'leftUpperArmGirth',
            },
            {
                title: 'Obvod pravé paže',
                key: 'rightUpperArmGirth',
            },
            {
                title: 'Obvod hrudníku',
                key: 'bustGirth',
            },
            {
                title: 'Obvod v pase (vysoko)',
                key: 'waistGirth',
            },
            {
                title: 'Obvod v pase (střed)',
                key: 'midWaistGirth',
            },
            {
                title: 'Obvod boků',
                key: 'hipGirth',
            },
            {
                title: 'Obvod levého stehna',
                key: 'leftThighGirth',
            },
            {
                title: 'Obvod středu levého stehna',
                key: 'leftMidThighGirth',
            },
            {
                title: 'Minimální obvod levého stehna',
                key: 'leftMinThighGirth',
            },
            {
                title: 'Obvod pravého stehna',
                key: 'rightThighGirth',
            },
            {
                title: 'Obvod středu pravého stehna',
                key: 'rightMidThighGirth',
            },
            {
                title: 'Minimální obvod pravého stehna',
                key: 'rightMinThighGirth',
            },
            {
                title: 'Obvod levého lýtka',
                key: 'leftCalfGirth',
            },
            {
                title: 'Obvod pravého lýtka',
                key: 'rightCalfGirth',
            },
            {
                title: 'Nízký pas',
                key: 'lowWaistGirth',
            },
        ],
    },
    // 肩部
    shoulder: {
        title: 'Funkce ramen',
        model: {
            val: 'Hodnoty',
            scope: 'Místo maximální aktivity',
            diff: 'Změna',
        },
        normal: 'Při hodnocení nebyly zjištěny žádné zjevné abnormality',
        normalAll: 'Při hodnocení nebyly zjištěny žádné zjevné abnormality',
        conclusion: 'Závěr',
        analyse: 'Analýza:',
        suggest: 'Doporučení:',
        cause: 'Pro další posouzení se prosím poraďte s odborníkem.',
    },
    reportTips: {
        title: "Opravdu chcete tuto zprávu odstranit? Po odstranění ji nebude možné obnovit.",
        confirm: "Odstranit",
        success: "Zpráva byla odstraněna",
        partial: "Zpráva byla odstraněna, některé údaje se nepodařilo synchronizovat. Kontaktujte správce.",
        failed: "Odstranění se nezdařilo, zkuste to prosím později znovu.",
        btnMsg: 'OK',
        alaryTips: 'Tato zpráva byla smazána správcem. Přesměrování na další zprávu.',
    },
    saveQr: {
        title: 'Zpráva o těle Visbody 3D',
        btnMsg: 'Dlouhým stisknutím obrázku uložíte do telefonu',
        tips: 'Pokud nelze uložit, povolte prosím oprávnění v [Nastavení]',
    },
    share: {
        title: 'Zkopírujte prosím níže uvedený odkaz pro sdílení',
        btnMsg: 'Kopírovat',
    },
    'bodyPrediction': {
        'body-title': '体型预测',
        'body-yu-ce-status': '根据您当前状态预测',
        'body-setting': '体型预测设置',
        'body-li-xiang': '理想值：',
        'body-ti-zhong': '体重',
        'body-ti-zhi-lv': '体脂率',
        'body-ji-rou': '肌肉含量',
        'yu-che-pre': '预测前',
        'yu-che-after': '预测后',
        'zan-model-no': '暂无模型',
        'ti-xing-error': '体型预测结果合成失败~',
        'ti-xing-worker-error': '小编猜测可能是网络原因导致的~',
        'ti-xing-adjust': '调节量',
        'ji-rou-title': '肌肉量',
        'ti-zi-fang': '体脂肪',
        'dang-pre-zhi': '当前值：',
        'nen-zhang': '内脏脂肪等级',
        'nen-zhang-title': '内脏脂肪面积说明',
        'nen-zhang-title1': '内脏脂肪分布在内脏器官之间得脂肪，易导致腹部肥胖，内脏脂肪面积显示的是内脏脂肪横截面积。'
    },
    ...csCZLocale,
    ...agrEn,
    wifi: {
        'title': 'WiFi配置',
        'tips': '请输入以下 WiFi 网络的密码',
        'password':'WIFI 密码',
        'password-placeholder': '请输入 WiFi 密码',
        'password-tips': '密码区分大小写，请确保输入正确',
        'button': '生成二维码',
        'h5-title': '配置WIFI信息',
        'wifi-name': 'WIFI名称:',
        'wifi-password': 'WIFI密码:',
        'wifi-qr-tips1': '* 请确认 WiFi 名称和密码无误后，对准设备屏幕下方的相机位置进行扫描。',
        'wifi-qr-tips2': '请将 WiFi 二维码对准屏幕下方的相机位置进行扫描。',
        'wifi-qr-button': '返回',
    },
    "waist": {
    "title": "Obvod Pasu a Břicha",
    "hou": "Zadní",
    "qian": "Přední"
  },
  "yao_wei_1": "Pas",
  "yao_bu_fen_shu": "Skóre Pasu",
  "waist_fen": "bodů",
  "yao_wei": "Obvod Pasu",
  "yao_wei_jian_ti_ji": "Objem Mezi Pasovými Liniemi",
  "yao_tun_bi": "Poměr pasu a boků",
  "lun_kuo_fen_xi": "Analýza Kontur",
  "bei_bu": "Oblast Zad",
  "tunbu": "Oblast Hýždí",
  "bei_bu_ti_ji": "Objem Zad",
  "zheng_chang_fan_wei": "Normální Rozsah:",
  "shang_ci": "Minulé ", 
  "ben_ci": "Nyní ",
  "gupen": {
    "zheng_chang": "Normální",
    "qian_qin_yan_chang": "Abnormální Předklon Pánve",
    "qian_qin_yi": "Riziko Předklonu Pánve",
    "hou_qin_yi": "Riziko Záklonu Pánve",
    "hou_qin_yan_chang": "Abnormální Záklon Pánve",
    "zuo_chang_yan_chang": "Abnormální Délka Levého Boku",
    "zuo_chang_yi": "Riziko Abnormální Délky Levého Boku",
    "you_chang_yi": "Riziko Abnormální Délky Pravého Boku",
    "you_chang_yan_chang": "Abnormální Délka Pravého Boku"
  },
  "gao_yao_xian": "Obvod v pase (vysoko)",
  "gao_yao_zhong_xian": "Střední Linie Vysokého Pasu",
  "gao_yao_xia_xian": "Spodní Linie Vysokého Pasu",
  "xiao_yao_shang_xian": "Horní Linie Nízkého Pasu",
  "xiao_yao_zhong_xian": "Střední Linie Nízkého Pasu",
  "xiao_yao_xian": "Nízký pas",
  "qv_jian1": "Horní Sekce Vysokého Pasu",
  "qv_jian2": "Spodní Sekce Vysokého Pasu",
  "qv_jian_zhong": "Střední Část Pasu",
  "qv_jian3": "Horní Sekce Nízkého Pasu",
  "qv_jian4": "Spodní Sekce Nízkého Pasu",
  "cun-zai-ming-xian-de-tou-bu-qian-qing-huo-ce-wai-jing-zhui-pai-lie-qing-du-pian-yi": "Předsunutí/náklon hlavy s mírnou odchylkou C-páteře. Dbejte na držení těla při sezení.",
  "tou-bu-ming-xian-qian-qing-huo-ce-wai-jing-zhui-pai-lie-zhong-du-pian-yi": "Předsunutí/náklon hlavy s odchylkou C-páteře. Doporučuje se kontrola držení těla a trénink.",
  "tou-bu-yan-zhong-qian-qing-huo-ce-wai-jing-zhui-pai-lie-yan-zhong-pian-yi": "Výrazné předsunutí/náklon hlavy a odchylka C-páteře. Doporučuje se odborné posouzení.",
  "xiong-zhui-pai-lie-qing-du-pian-yi-ke-neng-dui-sheng-huo-zhi-liang-you-qing-wei-ying-xiang": "Mírná odchylka Th-páteře. Doporučuje se zlepšení kontroly držení těla.",
  "xiong-zhui-pai-lie-zhong-du-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Odchylka Th-páteře ovlivňuje stabilitu. Doporučuje se cílený trénink.",
  "xiong-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang-ke-neng-zao-cheng-teng-tong-ji-qi-ta-ji-fa-xing-wen-ti": "Výrazná odchylka Th-páteře a asymetrie. Doporučuje se odborná korekce.",
  "yao-zhui-pai-lie-qing-du-pian-yi-sheng-wu-li-xian-shang-ke-dan-chang-qi-ke-neng-yin-fa-zi-shi-dai-chang": "Mírná odchylka L-páteře, postoj vyvážený. Doporučuje se stabilizace středu těla.",
  "yao-zhui-pai-lie-zhong-du-pian-yi-sheng-wu-li-xian-pian-yi-ke-neng-ying-xiang-zi-shi-he-sheng-huo-zhi-liang": "Odchylka L-páteře ovlivňuje stabilitu. Doporučuje se korekční trénink.",
  "yao-zhui-pai-lie-yan-zhong-pian-yi-sheng-wu-li-xian-xian-zhu-yi-chang": "Výrazná odchylka L-páteře. Doporučuje se odborný plán zlepšení.",
  "jian-jia-ti-ji-xiong-suo-ru-tu-ji-he-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-jing-shen-qu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-jing-bu-ji-rou-bing-jin-hang-shen-zhan-yun-dong": "Hypertonie: zdvihač lopatky, SCM, horní trapéz. Oslabení: hluboké flexory krku. Doporučuje se stabilizace a uvolnění.",
  "zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolorred-jin-zhang-span-you-ce-xiong-suo-ru-tu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertonie: levý SCM a zadní skalenus. Oslabení: pravý SCM. Doporučuje se oboustranná rovnováha a uvolnění.",
  "you-ce-xiong-suo-ru-tu-ji-span-stylecolorred-jin-zhang-span-zuo-ce-xiong-suo-ru-tu-ji-he-hou-jiao-xie-jiao-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-ping-heng-xun-lian": "Hypertonie: pravý SCM. Oslabení: levý SCM a zadní skalenus. Doporučuje se symetrická stabilizace a uvolnění.",
  "zuo-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertonie: levý horní trapéz. Oslabení: střední/dolní trapéz. Doporučuje se trénink (střed/spodek) a uvolnění.",
  "kuan-nei-xuan-ji-qun-he-nei-shou-ji-qun-span-stylecolorred-jin-zhang-span-tun-zhong-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-zhong-ji-la-shen-nei-shou-ji-qun": "Hypertonie: vnitřní rotátory a adduktory kyčle. Oslabení: m. gluteus medius. Doporučuje se trénink hýždí a protažení.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-nei-shou-ji-qun-la-shen-tun-zhong-ji-he-li-zhuang-ji": "Hypertonie: m. gluteus medius a piriformis. Oslabení: adduktory, vnitřní rotátory, LCL. Doporučuje se stabilizace nohou a uvolnění hýždí.",
  "tun-zhong-ji-he-li-zhuang-ji-span-stylecolorred-jin-zhang-span-dan-ce-kuan-nei-shou-ji-qun-nei-xuan-ji-qun-he-xi-wai-ce-fu-ren-dai-span-stylecolor5e92dd-wu-li-span-jian-yi-bao-chi-jun-heng-xun-lian-bi-mian-dan-ce-guo-du-shi-yong": "Hypertonie: m. gluteus medius a piriformis. Jednostranné oslabení: adduktory, vnitřní rotátory, LCL. Doporučuje se oboustranný trénink.",
  "zuo-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertonie: levé hamstringy a m. popliteus. Oslabení: kvadriceps a soleus. Doporučuje se trénink kvadricepsu/soleu a protažení.",
  "zuo-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertonie: levý kvadriceps. Oslabení: m. gluteus maximus a hamstringy. Doporučuje se trénink hýždí/zadního řetězce a protažení.",
  "you-ce-guo-sheng-ji-he-guo-ji-span-stylecolorred-jin-zhang-span-gu-si-tou-ji-he-bi-mu-yu-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-gu-si-tou-ji-la-shen-guo-sheng-ji": "Hypertonie: pravé hamstringy a m. popliteus. Oslabení: kvadriceps a soleus. Doporučuje se trénink kvadricepsu/soleu a protažení.",
  "you-ce-gu-si-tou-ji-span-stylecolorred-jin-zhang-span-tun-da-ji-he-yan-sheng-ji-span-stylecolor5e92dd-wu-li-span-jian-yi-jia-qiang-tun-da-ji-he-yan-sheng-ji-la-shen-gu-si-tou-ji": "Hypertonie: pravý kvadriceps. Oslabení: m. gluteus maximus a hamstringy. Doporučuje se trénink hýždí/zadního řetězce a protažení.",
  "ji-zhu-jie-gou-qing-du-yi-chang-jian-yi-jia-qiang-zi-shi-guan-li-he-he-xin-ji-qun-xun-lian": "Mírná odchylka páteře. Dbejte na držení těla a posilujte střed.",
  "ji-zhu-jie-gou-zhong-du-yi-chang-jian-yi-zhuan-ye-jiao-zheng-gan-yu-bing-ding-qi-fu-cha-ping-gu": "Střední odchylka páteře. Doporučuje se odborně vedený trénink.",
  "you-ce-xie-fang-ji-shang-shu-span-stylecolorred-jin-zhang-span-zhong-xia-shu-span-stylecolor5e92dd-wu-li-span-jian-yi-jin-hang-xie-fang-ji-zhong-xia-shu-qiang-hua-he-shang-shu-fang-song-xun-lian": "Hypertonie: pravý horní trapéz. Oslabení: střední/dolní trapéz. Doporučuje se trénink (střed/spodek) a uvolnění.",
  "neckReport": {
  "title": "Funkce krku",
  "conclusion": "Hodnocení funkce krku",
  "loading": "Zpráva se vytváří. Čekejte prosím.",
  "failed": "Syntéza selhala",
  "analysis": "Analýza",
  "suggestion": "Doporučení",
  "suggestionText": "Vyhledejte odborníka pro další vyšetření a léčbu příčin."
}
}
